import React from 'react'

import { colors as zetColors } from '@zet/design-system'
import { Icon } from '@zet/design-system/icons'
import { XStack } from '@zet/design-system/layout'
import Pressable from '@zet/design-system/pressable'
import { LinearGradient } from 'expo-linear-gradient'
import { ModalComponentProp } from 'react-native-modalfy'
import { SafeAreaView } from 'react-native-safe-area-context'

import Success from '@components/quiz/success'

import { ModalStackParams } from '../modalConfig'

type Props = ModalComponentProp<
  ModalStackParams,
  void,
  'DownloadCertificateModal'
>

export default function DownloadCertificateModal({
  modal: { closeModal, getParam },
}: Props) {
  const description2 = getParam('certificateDescription2')
  const description1 = getParam('certificateDescription1')

  return (
    <SafeAreaView style={{ flex: 1 }}>
      <LinearGradient
        colors={[zetColors.tertiary[100], zetColors.tertiary[100]]}
        className="flex h-screen w-screen flex-1"
      >
        <XStack className="mb-8 ml-3 mt-3">
          <Pressable
            className="bg-decorative-steelblue-translucent mr-3 rounded p-1"
            onPress={() => closeModal()}
          >
            <Icon type="Close" color={zetColors.grays[10]} />
          </Pressable>
        </XStack>
        <Success
          certificateDescription1={description1}
          certificateDescription2={description2}
        />
      </LinearGradient>
    </SafeAreaView>
  )
}
